export default __webpack_public_path__ + "static/media/computer.79cbf471.png";